// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { connect, useDispatch, useStore, useSelector } from '/home/fastex/reportsystem/webadmin/node_modules/.pnpm/@umijs+plugins@4.3.20_@babel+core@7.22.5_@types+react@18.3.25_antd@4.24.15_react-dom@18_6a73db41a43e4a621d32c2eb3eac3226/node_modules/@umijs/plugins/libs/dva.tsx';
export { getDvaApp } from './dva';
